import { render, staticRenderFns } from "./VendedorShow.vue?vue&type=template&id=25a3bb31&"
import script from "./VendedorShow.vue?vue&type=script&lang=js&"
export * from "./VendedorShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports